import AnimatedSprite from 'slotworks/graphics/animation/animated-sprite';
import { ButtonEvent } from 'slotworks/graphics/elements/button-element';
import FlexiButton from 'slotworks/graphics/elements/flexi-button';
import FlexiText from 'slotworks/graphics/elements/flexi-text';
import FlexiToggle, { ToggleEvent } from 'slotworks/graphics/elements/flexi-toggle';
import Layers from 'slotworks/graphics/layers/layers';
import soundManager from 'slotworks/sound/sound-manager';
import Contract from 'slotworks/utils/contract';

export default class SoundPopup {
    private static BUTTON_OK: string = 'btn-ok';
    private static TOGGLE_SOUND: string = 'soundfx';
    private layer: Layers;
    private okButton: FlexiButton;
    private okLabel: FlexiText;
    private soundFlexiToggle: FlexiToggle;
    private loadingLabel: FlexiText;
    private soundAnimation: AnimatedSprite;
    private inResolve: Function;
    private loaded: boolean = false;

    constructor() {
        this.close = this.close.bind(this);
    }

    public show(): Contract<void> {
        return new Contract(resolve => {
            this.inResolve = resolve;
            this.layer = Layers.Custom.get('IntroPopups');
            this.layer.setScene('soundintro').execute();
            this.setup();
            this.layer.show();
        });
    }

    public close() {
        this.soundFlexiToggle.getValue() ? soundManager.unmute() : soundManager.mute();
        this.hide();
        this.inResolve(null);
    }

    private setSoundDisabled = (disabled: boolean) => {
        if (!this.loaded) {
            this.okButton?.setVisible(disabled);
            this.okButton?.setEnabled(disabled);
            this.okLabel?.setVisible(disabled);
            this.loadingLabel.setVisible(!disabled);
        } else {
            disabled ? soundManager.mute() : soundManager.unmute();
        }
    };

    private onSoundFlexiChange = () => {
        this.setSoundDisabled(!this.soundFlexiToggle.getValue());
    };

    private setup() {
        this.okButton = this.layer.getFlexiButton(SoundPopup.BUTTON_OK);
        this.okButton.setEnabled(true);
        this.okButton.on(ButtonEvent.POINTER_UP, this.close);
        this.okLabel = this.layer.getFlexiText('btn-ok-lbl');
        this.loadingLabel = this.layer.getFlexiText('loading');
        this.soundAnimation = this.layer.getAnimatedSprite('audio_loading_icon');

        this.soundFlexiToggle = this.layer.getFlexiToggle(SoundPopup.TOGGLE_SOUND);
        this.soundFlexiToggle.on(ToggleEvent.CHANGE, this.onSoundFlexiChange);

        const onDone = () => {
            this.loaded = true;
            this.okButton.setVisible(true);
            this.okButton.setEnabled(true);
            this.okLabel?.setVisible(true);
            this.loadingLabel.setVisible(false);
            this.soundAnimation?.gotoAndStop(0);
            if (this.soundFlexiToggle.getValue()) {
                soundManager.unmute();
            }
        };

        this.okButton.setVisible(false);
        this.okButton.setEnabled(false);
        this.okLabel?.setVisible(false);

        if (soundManager.getLoaded()) {
            onDone();
        } else if (soundManager.getLoading()) {
            soundManager.onLoadComplete.addOnce(onDone);
        } else {
            soundManager.loadSounds();
            soundManager.onLoadComplete.addOnce(onDone);
        }

        this.soundFlexiToggle?.setValue(!soundManager.getMuted());
    }

    private hide() {
        this.okButton.off(ButtonEvent.POINTER_UP, this.close);
        this.okButton.setEnabled(false);
        this.soundFlexiToggle.off(ToggleEvent.CHANGE, this.onSoundFlexiChange);
        this.layer.defaultScene().execute();
        this.layer.hide();
    }
}



// WEBPACK FOOTER //
// ./src/components/sound-popup.ts